import { Set } from 'immutable'

export type ValidationResult = {
  status: 'valid' | 'unknown'
} | {
  status: 'invalid'
  message: string
}

// Value Validators

export type Validator<I> = (input: I) => ValidationResult

export const cannotBeNullOrUndefined: (message?: string) => Validator<unknown> =
  (message = "Cannot be empty") => (input: unknown) => input == null || input == undefined ? invalid(message) : unknown

export const canBeEmptyString: Validator<string> = (input: string) =>
  isEmptyString(input) ? valid : unknown

export const cannotBeEmptyString: (message?: string) => Validator<string> =
  (message = "Cannot be empty") => (input: string) => isEmptyString(input) ? invalid(message) : unknown

export const mustBeValidEmail: (message?: string) => Validator<string> =
  (message = "Must be valid email address") => (input: string) => isValidEmail(input) ? valid : invalid(message)

export const cannotBeHigherThan: (max: number, message?: string) => Validator<number> =
  (max, message = "Must be valid email address") => (input: number) => input <= max ? valid : invalid(message)

export const cannotBeEmptySet: (message?: string) => Validator<Set<unknown>> =
  (message = "Set cannot be empty") => (input: Set<unknown>) => input.size > 0 ? valid : invalid(message)

// Predicates

const isEmptyString = (i: string) => i.trim().length == 0

const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
const isValidEmail = (input: string) => input.match(emailRegex)

// Constants

export const valid: ValidationResult = { status: 'valid' }
export const unknown: ValidationResult = { status: 'unknown' }
export const invalid: (message: string) => ValidationResult = (message) => ({ status: 'invalid', message })
